//function initMap() {
//    map = new google.maps.Map(document.getElementById('map'), {
//        zoom: zoom,
//        center: startPos
//    });
//    placeMarker(startPos);
//}

//function placeMarker(location) {
//    var marker = new google.maps.Marker({
//        position: location,
//        map: map
//    });
//}


var markers = [];
var map = null;
var angularReady = false;


function initMap(startPos, zoom) {
    if (typeof startPos === 'undefined') {
        startPos = { lat: 55.8591118, lng: -4.2603028 };
    }
    if (typeof zoom === 'undefined') {
        zoom = 5;
    }
    map = new google.maps.Map(document.getElementById('map'), {
        zoom: zoom,
        center: startPos
    });

    placeMarker(startPos);

    //google.maps.event.addListener(map, 'click', function (event) {
    //    placeMarker(event.latLng);
    //});
}

function clearOverlays() {
    for (var i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
    }
    markers.length = 0;
}


function placeMarker(location) {

    //console.log(location.lat + " , " + location.lng);

    var marker = new google.maps.Marker({
        position: location,
        map: map
    });
    markers.push(marker);
}


function getBounds() {
    var bounds = new google.maps.LatLngBounds();
    //  Go through each...
    $.each(markers, function (index, value) {
        bounds.extend(markers[index].getPosition());
    });
}

/*
$(function () {
    initMap();
});
*/